module.exports = __webpack_public_path__ + "r-v3/img/ico_close_white.0f8cb496.svg";